<template>
  <div class="overlay">
    <div class="download-content">
      <div class="header">
        <img src="../../../../assets/images/motionbank-logo.png" alt="">
        <svg @click="$emit('close')" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" fill="#C62127"/>
          <path d="M16.7785 7.22908C16.7083 7.15877 16.625 7.10298 16.5332 7.06492C16.4415 7.02686 16.3431 7.00726 16.2438 7.00726C16.1444 7.00726 16.0461 7.02686 15.9543 7.06492C15.8625 7.10298 15.7792 7.15877 15.709 7.22908L12 10.9305L8.29097 7.2215C8.22075 7.15127 8.13738 7.09557 8.04563 7.05756C7.95388 7.01956 7.85554 7 7.75623 7C7.65692 7 7.55859 7.01956 7.46683 7.05756C7.37508 7.09557 7.29172 7.15127 7.2215 7.2215C7.15127 7.29172 7.09557 7.37508 7.05756 7.46683C7.01956 7.55859 7 7.65692 7 7.75623C7 7.85554 7.01956 7.95388 7.05756 8.04563C7.09557 8.13738 7.15127 8.22075 7.2215 8.29097L10.9305 12L7.2215 15.709C7.15127 15.7793 7.09557 15.8626 7.05756 15.9544C7.01956 16.0461 7 16.1445 7 16.2438C7 16.3431 7.01956 16.4414 7.05756 16.5332C7.09557 16.6249 7.15127 16.7083 7.2215 16.7785C7.29172 16.8487 7.37508 16.9044 7.46683 16.9424C7.55859 16.9804 7.65692 17 7.75623 17C7.85554 17 7.95388 16.9804 8.04563 16.9424C8.13738 16.9044 8.22075 16.8487 8.29097 16.7785L12 13.0695L15.709 16.7785C15.7793 16.8487 15.8626 16.9044 15.9544 16.9424C16.0461 16.9804 16.1445 17 16.2438 17C16.3431 17 16.4414 16.9804 16.5332 16.9424C16.6249 16.9044 16.7083 16.8487 16.7785 16.7785C16.8487 16.7083 16.9044 16.6249 16.9424 16.5332C16.9804 16.4414 17 16.3431 17 16.2438C17 16.1445 16.9804 16.0461 16.9424 15.9544C16.9044 15.8626 16.8487 15.7793 16.7785 15.709L13.0695 12L16.7785 8.29097C17.0667 8.00274 17.0667 7.51731 16.7785 7.22908Z" fill="white"/>
        </svg>
      </div>
      <div class="body">
        <p>Unduh dan daftar segera MotionBanking anda</p>
        <img src="../../../../assets/images/Ilustration-download-motion-bank.png" alt="">
        <button @click="download" class="button-primary text-bold w-full p-1rem">Unduh Sekarang</button>
      </div>
    </div>
  </div>
</template>

<script setup>
const download = () => {
  const userAgent = navigator.userAgent || window.opera

  if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i) || userAgent.match(/iPod/i)) {
    return window.open('https://apps.apple.com/id/app/motion-banking/id1506555741')
  } else if (userAgent.match(/Android/i)) {
    return window.open('https://play.google.com/store/apps/details?id=com.mnc.mbanking')
  } else {
    return window.open('https://play.google.com/store/apps/details?id=com.mnc.mbanking')
  }
}
</script>

<style lang="scss" scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #3e3e3e32;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;

  .download-content {
    margin: .5rem;
    background-color: $white;
    padding: 2rem;
    border-radius: 10px;
    gap: 1rem;
    display: flex;
    flex-direction: column;

    .header {
      display: flex;
      justify-content: space-between;
      img {
        height: 22px;
      }
    }

    .body {
      p {
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 150%;
        /* identical to box height, or 24px */

        /* Primary/Blue */

        color: #253E80;
      }

      img {
        margin: 0 auto;
      }
    }
  }
}
</style>
